import { atom } from "jotai";

export const openCartAtom = atom(false);
export const openNavbarAtom = atom(false);
export const openSidebarAtom = atom(false);
export const openPopupAtom = atom(false);

export const openNewsletterPopup = atom(false);
export const openAccountPopupAtom = atom(false);
export const isOpenPasswordRestoredPopupAtom = atom(false);
export const isOpenChangePasswordAtom = atom(false);
